import { doc, getDoc, getFirestore } from 'firebase/firestore'
import { getFirebaseApp } from '../../config/firebase'

export type AppRole = 'admin' | 'employee' | 'parent'

export type UserMembership = {
  role: AppRole
  schoolId: string
  active: boolean
}

function isAppRole(value: unknown): value is AppRole {
  return value === 'admin' || value === 'employee' || value === 'parent'
}

function membershipFromData(data: Record<string, unknown> | undefined): UserMembership | null {
  const role = data?.role
  const schoolId = data?.schoolId
  const active = data?.active
  if (!isAppRole(role) || typeof schoolId !== 'string' || active !== true) return null
  return { role, schoolId, active }
}

export async function getUserMembership(uid: string): Promise<UserMembership | null> {
  const firestore = getFirestore(getFirebaseApp())

  // C4 decision: membership is authoritative for authorization and role gates.
  const membership = await getDoc(doc(firestore, 'roles_memberships', uid))
  return membershipFromData(membership.data() as Record<string, unknown> | undefined)
}

export async function getUserRole(uid: string): Promise<AppRole | null> {
  const membership = await getUserMembership(uid)
  return membership?.role ?? null
}
